import { SeDateTimeString, SeDateTimeOptions } from './date-time-types'
import { SeRangeFormatter } from './range-formatter'
import { SeTimeFormatter } from './time-formatter'
import { SeTime } from './time'
import { SeDateFormatter } from './date-formatter'
import { extendClass } from './extend-class'
import { SeDateTimeFormat } from './date-time-types'

export class SeTimeRange {

  constructor(
    startValue: SeDateTimeString,
    endValue: SeDateTimeString,
    options: SeDateTimeOptions
  ) {
    this.initTime(startValue, options)
    this.initRange(startValue, endValue, options, SeTime)
    this.addConditions([
      { [SeDateTimeFormat.DifferentMeridiem]: () => this.differentMeridiem }
    ])
  }

  private get differentMeridiem(): boolean {
    return this.cached('showMeridiem', () => {
      const s = this.start.luxon
      const e = this.end.luxon
      return s.startOf('day').toSeconds() !== e.startOf('day').toSeconds() || s.toFormat('a') !== e.toFormat('a')
    })
  }

}

export interface SeTimeRange extends SeDateFormatter, SeTimeFormatter, SeRangeFormatter<SeTime> {}
extendClass(SeTimeRange, SeDateFormatter, SeTimeFormatter, SeRangeFormatter)
